import { render, staticRenderFns } from "./TwoLine.vue?vue&type=template&id=47e48ec0&scoped=true"
import script from "./TwoLine.vue?vue&type=script&lang=js"
export * from "./TwoLine.vue?vue&type=script&lang=js"
import style0 from "./TwoLine.vue?vue&type=style&index=0&id=47e48ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e48ec0",
  null
  
)

export default component.exports